import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ICmsHomeBannerResponse } from "../../Orchestrator/Types/Interface/ICmsHomePageBanner";

export async function getCmsHomeBannerList(queryParams?: Record<string, any>): Promise<
  IApiResponse<ICmsHomeBannerResponse>
> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCmsHomeBannerAPI;

  const params = new URLSearchParams({
    "populate": "*",
    locale: await getLocaleFromCookie(),
    ...queryParams,
  });

  // When the caller already constrains offer_banner (e.g. the offers page asks
  // for offer_banner=true), respect it. Otherwise default to the home banners:
  // the non-offer ones. Legacy CMS entries can have offer_banner unset (null)
  // instead of false, and Strapi's $eq=false / $ne=true filters both exclude
  // null rows — so match "false OR null" explicitly via $or, otherwise those
  // banners never get returned and the carousel renders empty.
  const callerConstrainsOfferBanner = Object.keys(queryParams ?? {}).some((key) =>
    key.startsWith("filters[offer_banner]")
  );
  if (!callerConstrainsOfferBanner) {
    params.set("filters[$or][0][offer_banner][$eq]", "false");
    params.set("filters[$or][1][offer_banner][$null]", "true");
  }

  const endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsHomeBannerResponse>(endpointWithParams, "GET");
}

